import { unprotect } from 'mobx-state-tree'
import { RootModel } from './modules/root'

let store: RootModel
export type Store = RootModel
export { store }

const enableDebugging = async () => {
  // eslint-disable-next-line import/no-extraneous-dependencies
  const makeInspectable = await import('mobx-devtools-mst')
  makeInspectable.default(store)
}

const isDevelopment = process.env.NODE_ENV === 'development'

const logStore = (message: string, data?: unknown) => {
  if (isDevelopment) {
    console.log(`[Store] ${message}`, data || '')
  }
}

const createGlobalStore = async () => {
  logStore('Creating global store...')
  if (typeof window !== 'undefined') {
    if (!window.store) {
      window.store = RootModel.create()
      logStore('Created new store instance')
    } else {
      logStore('Using existing store instance')
    }
    store = window.store
  } else {
    store = RootModel.create()
    logStore('Created store (server-side)')
  }
  if (store.debug) enableDebugging()
  if (process.env.NODE_ENV === 'test' && !process.env.ACCEPTANCE_SPEC) {
    unprotect(store)
  }

  // Wait a tick to ensure event listeners are registered before dispatching
  // This prevents race conditions where the event is dispatched before listeners are set up
  await new Promise((resolve) => setTimeout(resolve, 0))

  logStore('Dispatching storeLoaded event', {
    bootstrapping: store.bootstrapping,
  })
  document.dispatchEvent(new CustomEvent('storeLoaded', { detail: store }))
  logStore('storeLoaded event dispatched')
}

createGlobalStore()
